export const RESET = 'EXCMREGION_LIST_RESET'
export const SET_ITEMS = 'EXCMREGION_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMREGION_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMREGION_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMREGION_LIST_TOGGLE_LOADING'
